<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <FormInput :label="teatro.hash !== 'XSb8uxOmqRUI9fMC3Kos' ? $t('formularios.dni') : 'Usuario'" name="dni" rules="required" id="dni" v-model="abonado.dni" />
        <FormInput v-if="teatro.hash !== '2IcJsvmDMf3LM9rJREmH'" class="mb-3 mb-lg-4" :label="teatro.hash !== 'XSb8uxOmqRUI9fMC3Kos' ? $t('formularios.n_abonado', {abonado: teatro.texto_abonado}) : 'PIN'" name="n_abonado" id="n_abonado" rules="required" v-model="abonado.n_abonado" />
        <button type="submit" :disabled="abonadoSeleccionado" class="button large-button effect-button"><span>{{ $t('partido.buscar') }}</span></button>
    </ValidationObserver>
</template>

<script>
    export default {
        props: ['abonado', 'abonadoSeleccionado'],
        data() {
            return {
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.terminar();
                }
            },
            terminar() {
                this.$emit('terminado');
            }
        },
        computed: {
            teatro(){
                return this.$store.getters.getTeatro;
            },
        }
    }
</script>
